export const leftPanelStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  titleSection: {
    marginBottom: {
      xs: '40px',
      lg: '50px',
    },
  },
  title: {
    fontSize: {
      xs: '28px',
      sm: '32px',
      md: '42px',
    },
    fontWeight: 600,
    color: '#000000',
    marginBottom: '12px',
    lineHeight: 1.2,
  },
  subtitle: {
    fontSize: {
      xs: '14px',
      sm: '16px',
      md: '18px',
    },
    fontWeight: 400,
    color: '#666666',
    fontStyle: 'italic',
  },
};
